import React, { useState, useCallback, useEffect } from "react";
import {
    Layout,
    Card,
    FormLayout,
    TextField,
    Select,
    Popover,
    hsbToHex,
    Button,
    rgbToHsb,
    rgbString,
    hsbToRgb,
    Stack,
    Toast,
    ColorPicker,
    Badge,
    Tag,
    Banner,
    Checkbox, DropZone
} from "@shopify/polaris";
import _ from "lodash";

import { useDispatch, useSelector } from "react-redux";
import { ResourcePicker } from "@shopify/app-bridge-react";

import * as authService from "../../services/authService";

import Loader from "../../Loader";
export default function Customisemsg() {
    const [selected, setSelected] = useState("null");
    const [backGroundImage, setBackGroundImage] = useState(null);
    const [heading, setHeading] = useState("");
    const [message, setMessage] = useState("");
    const [buttonText, setButtonText] = useState("");
    const [buttonColor, setButtonColor] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadingGet, setLoadingGet] = useState(false);
    const [errorflag, setErrorflag] = useState(false);
    const [successflag, setSuccessflag] = useState(false);
    const [popoverActivePrimary, setPopoverActivePrimary] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(null);

    const [removeBranding, setRemoveBranding] = useState(false)
    const [topPosition, setTopPosition] = useState(false)

    //new code

    const [ProductModal, setProductModal] = useState(false);
    const [CollectionModal, setCollectionModal] = useState(false);

    const [product, setProduct] = useState(null);
    const [productSelectorArray, setProductSelectorArray] = useState([]);

    const [collection, setCollection] = useState(null);
    const [collectionSelectorArray, setcollectionSelectorArray] = useState([]);

    const [selectedProduct, setselectedProduct] = useState({});
    const [selectedCollection, setselectedCollection] = useState({});

    const [pwdText, setPwdText] = useState({});
    const [confirmPwdText, setConfirmPwdText] = useState({});

    //new code end

    const shop_plan = useSelector((state) => state.allReducer.shop_plan);

    const toggleActive = useCallback(
        () => setErrorflag((errorflag) => !errorflag),
        []
    );
    const toggleSuccessActive = useCallback(
        () => setSuccessflag((successflag) => !successflag),
        []
    );

    const handleSelectChange = useCallback((label) => {
        setSelected(label);
    }, []);
    const [primaryColor, setPrimaryColor] = useState({
        hue: 231.04477611940297,
        brightness: 0.84375,
        saturation: 0.5828125,
    });

    const [primaryHexColor, setPrimaryHexColor] = useState(
        hsbToHex(primaryColor)
    );

    const togglePopoverActivePrimary = useCallback(
        () =>
            setPopoverActivePrimary(
                (popoverActivePrimary) => !popoverActivePrimary
            ),
        []
    );
    useEffect(() => {
        setLoadingGet(true);
        authService
            .customizeMsg_Get()
            .then((response) => {
                setLoadingGet(false);


                if (
                    response &&
                    response.data &&
                    response.data.data &&
                    response.data.data.response
                ) {
                    var p_id = response.data.data.response;
                    var data = response.data.data.response.response;


                    if (data && data.msg_heading) {
                        setHeading(data.msg_heading);
                    }
                    if (data && data.redirectUrl) {
                        setRedirectUrl(data.redirectUrl);
                    }
                    if (data && data.message) {
                        setMessage(data.message);
                    }
                    if (data && data.pwdText) {
                        setPwdText(data.pwdText);
                    }

                    if (data && data.confirmPwdText) {
                        setConfirmPwdText(data.confirmPwdText);
                    }
                    if (data && data.button_txt) {
                        setButtonText(data.button_txt);
                    }
                    if (data && data.button_color) {
                        setPrimaryHexColor(data.button_color);
                        var value = data.button_color;
                        if (value.length === 7) {
                            let rgbValue = hexToRgb(value);
                            let hsba = rgbToHsb(rgbValue);
                            setPrimaryColor(hsba);
                        }
                    }
                    if (data && data.img_icon) {
                        setSelected(data.img_icon);
                    }
                    if (data && data.background_image) {
                        setBackGroundImage(data.background_image);
                    }
                    if (data && data.removeBranding) {
                        setRemoveBranding(data.removeBranding)
                    }
                    if (data && data.topPosition) {
                        setTopPosition(data.topPosition)
                    }
                    if (p_id && p_id.products) {
                        setselectedProduct(p_id.products);
                        funselectedproductSelections(p_id.products);
                    }
                    if (p_id.collections) {
                        setselectedCollection(p_id.collections);
                        funselectedcollectionSelections(p_id.collections);
                    }
                }
            })
            .catch((error) => {
                setLoadingGet(false);
                setErrorflag(true);
                console.log("error", error);
            });
    }, []);


    const rgbaColorPrimary = rgbString(hsbToRgb(primaryColor));
    const activatorPrimary = (
        <div>
            <label>Button Color</label>

            <div style={{ paddingTop: "3px" }}>
                <Button
                    onClick={togglePopoverActivePrimary}
                    disclosure
                    disabled={
                        shop_plan && shop_plan.plan === "basic" ? true : false
                    }
                >
                    {/* {/ Primary color /} */}
                    <div>
                        <Stack alignment="center" spacing="tight">
                            <div
                                style={{
                                    height: "2rem",
                                    width: "2rem",
                                    borderRadius: "0.3rem",
                                    background: rgbaColorPrimary,
                                }}
                            />
                            <span>{primaryHexColor}</span>
                        </Stack>
                    </div>
                </Button>
            </div>
        </div>
    );

    const handlePrimaryColorChange = (value) => {
        let hexColor = hsbToHex(value);

        setPrimaryHexColor(hexColor);
        setPrimaryColor(value);
    };

    const handlePrimaryHexColorChange = (value) => {
        if (value.charAt(0) === "#" && value.length <= 7) {
            setPrimaryHexColor(value);
            if (value.length === 7) {
                let rgbValue = hexToRgb(value);
                let hsba = rgbToHsb(rgbValue);
                setPrimaryColor(hsba);
            }
        }
    };
    const hexToRgb = (hex) => {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                red: parseInt(result[1], 16),
                green: parseInt(result[2], 16),
                blue: parseInt(result[3], 16),
            }
            : {
                red: 0,
                green: 0,
                blue: 0,
            };
    };
    const options = [
        { label: "Star", value: "star" },
        { label: "Bell", value: "bell" },
        { label: "Diamond", value: "diamond" },
        { label: "Glob", value: "globe" },
        { label: "Heart", value: "heart" },
        { label: "Lock", value: "lock" },
        { label: "Blank", value: "null" },
    ];

    const onImageChange = (_dropFiles, acceptedFiles, _rejectedFiles) => {
        if (acceptedFiles && acceptedFiles[0]) {
            if (acceptedFiles[0] && acceptedFiles[0].size > 409600) {
                alert("File size should be less than 400KB.");
                document.getElementById("imgInp").value = "";
            } else {
                let reader = new FileReader();
                reader.onload = (e) => {
                    setBackGroundImage(e.target.result);
                };
                reader.readAsDataURL(acceptedFiles[0]);
            }
        }
    };

    const addNewData = () => {
        setLoading(true);

        var selectionProductObj = {};
        var selectionCollectionObj = {};
        if (
            product &&
            product.selection &&
            Array.isArray(product.selection) &&
            product.selection.length > 0
        ) {
            product.selection.forEach((item) => {
                const item_id = item.id.split("/").splice(-1).pop();
                const title = item.title;

                selectionProductObj[item_id] = title;
            });
        } else {
            selectionProductObj = selectedProduct;
        }

        if (
            collection &&
            collection.selection &&
            Array.isArray(collection.selection) &&
            collection.selection.length > 0
        ) {
            collection.selection.forEach((item) => {
                const item_id = item.id.split("/").splice(-1).pop();

                const title = item.title;

                selectionCollectionObj[item_id] = title;
            });
        } else {
            selectionCollectionObj = selectedCollection;
        }
        var data = {
            heading: heading,
            message: message,
            btnTxt: buttonText,
            btnColor: primaryHexColor,
            redirectUrl,
            gifName: selected,
            img: backGroundImage,
            products: selectionProductObj,
            collections: selectionCollectionObj,
            pwdText: pwdText,
            confirmPwdText: confirmPwdText,
            removeBranding: removeBranding,
            topPosition: topPosition
        };

        authService
            .customizeMsg(data)
            .then((response) => {
                setLoading(false);
                setSuccessflag(true);
            })
            .catch((error) => {
                setLoading(false);
                setErrorflag(true);
                console.log("error", error);
            });
    };
    const desc = (
        <div>
            Edit your account activation message here. This will display on the
            order confirmation page. <br />
            {shop_plan && shop_plan.plan === "basic" ? (
                <Badge status="attention">Locked</Badge>
            ) : (
                <Badge status="success">Active</Badge>
            )}
        </div>
    );

    const desc_logic = (
        <div>
            Only show account activation section if the following
            products/collections are included in the order. <br />
            {shop_plan && shop_plan.plan === "basic" ? (
                <Badge status="attention">Locked</Badge>
            ) : (
                <Badge status="success">Active</Badge>
            )}
        </div>
    );

    //new Code

    const toggleProductModel = () => {
        setProductModal(!ProductModal);
    };

    const toggleCollectionModel = () => {
        setCollectionModal(!CollectionModal);
    };

    function funproductSelections(selectPayload) {
        var productSelectorArr = [];
        var id = "";
        selectPayload &&
            selectPayload.selection &&
            Array.isArray(selectPayload.selection) &&
            selectPayload.selection.length > 0 &&
            selectPayload.selection.map((item, index) => {
                id = item.id;
                productSelectorArr.push({ id });
            });
        setProductSelectorArray(productSelectorArr);
    }

    function funCollectionSelection(selectPayload) {
        const collectionSelectorArray = [];

        selectPayload &&
            selectPayload.selection &&
            Array.isArray(selectPayload.selection) &&
            selectPayload.selection.length > 0 &&
            selectPayload.selection.map((item, index) => {
                const id = item.id;
                collectionSelectorArray.push({ id: id });
            });

        setcollectionSelectorArray(collectionSelectorArray);
    }

    const removeProduct = (item) => {
        let newVar = _.remove(product.selection, function (selection) {
            return selection.id !== item.id;
        });
        var new_coll = Object.assign({}, product);
        new_coll.selection = newVar;
        setProduct(new_coll);

        funproductSelections(new_coll);
    };

    const removeCollection = (item) => {
        let newVar = _.remove(collection.selection, function (selection) {
            return selection.id !== item.id;
        });
        var new_coll = Object.assign({}, collection);
        new_coll.selection = newVar;
        setCollection(new_coll);

        funCollectionSelection(new_coll);
    };

    const removeSelectedProduct = (item, key) => {
        let pickitem = _.pick(selectedProduct, [key]);
        var selectedItem = _.omit(selectedProduct, Object.keys(pickitem));

        setselectedProduct(selectedItem);
        funselectedproductSelections(selectedItem);
    };

    const removeSelectedCollection = (item, value) => {
        let pickitem = _.pick(selectedCollection, value[0]);
        var selectedItem = _.omit(selectedCollection, Object.keys(pickitem));
        setselectedCollection(selectedItem);
        funselectedcollectionSelections(selectedItem);
    };

    function funselectedproductSelections(selectedItem) {
        const productSelectorArray = [];
        Object.keys(selectedItem).forEach((key) => {
            const id = `gid://shopify/Product/${key}`;

            productSelectorArray.push({ id: id });
        });

        setProductSelectorArray(productSelectorArray);
    }

    function funselectedcollectionSelections(selectedItem) {
        const collectionSelectorArray = [];
        Object.keys(selectedItem).forEach((key) => {
            const id = `gid://shopify/Collection/${key}`;

            collectionSelectorArray.push({ id: id });
        });

        setcollectionSelectorArray(collectionSelectorArray);
    }

    return (
        <div>
            {loadingGet && <Loader />}
            {errorflag && (
                <Toast content="Server error" error onDismiss={toggleActive} />
            )}
            {successflag && (
                <Toast content="Success" onDismiss={toggleSuccessActive} />
            )}
            <Layout>
                <Layout.AnnotatedSection
                    title="Customise Your Message"
                    description={desc}
                >
                    <Card sectioned>
                        <FormLayout>
                            <div>
                                {shop_plan.plan === "basic" &&
                                    <div>
                                        <Banner  >
                                            <p>To change default settings you will need to upgrade from free plan</p>
                                        </Banner>
                                        <br />
                                    </div>
                                }

                            </div>
                            <FormLayout.Group>

                                <div>


                                    <div>
                                        <label
                                            for="inputHeading"
                                            class="col-form-label"
                                        >
                                            Upload Image
                                        </label>

                                    </div>
                                    <div style={{ display: "inline-flex" }}>

                                        <div style={{ width: 50, height: 50 }}>
                                            <DropZone onDrop={onImageChange}
                                                disabled={shop_plan &&
                                                    shop_plan.plan === "basic"
                                                    ? true
                                                    : false}>
                                                <DropZone.FileUpload />
                                            </DropZone>
                                        </div>
                                        {backGroundImage && (
                                            <div
                                                style={{
                                                    paddingLeft: "25px",
                                                    display: "flex",
                                                }}
                                            >
                                                <img
                                                    style={{
                                                        height: "50px",
                                                        width: "50px",
                                                    }}
                                                    src={backGroundImage}
                                                ></img>
                                                <h4
                                                    style={{
                                                        cursor: "pointer",
                                                        marginTop: "-9px",
                                                        marginLeft: "1px",
                                                    }}
                                                    onClick={() => {
                                                        setBackGroundImage(
                                                            null
                                                        );
                                                        document.getElementById(
                                                            "imgInp"
                                                        ).value = "";
                                                    }}
                                                >
                                                    ❌
                                                </h4>
                                            </div>
                                        )}
                                    </div>
                                    {/* <input
                                        onChange={onImageChange}
                                        data-max-file-size="409600"
                                        id="imgInp"
                                        class="custom-file"
                                        style={{
                                            width: "250px",
                                            overflow: "hidden",
                                        }}
                                        disabled={
                                            shop_plan &&
                                                shop_plan.plan === "basic"
                                                ? true
                                                : false
                                        }
                                        type="file"
                                        name="backGroundImage"
                                    /> */}
                                </div>

                                <Select
                                    label="Or choose an animated icon"
                                    options={options}
                                    disabled={
                                        shop_plan && shop_plan.plan === "basic"
                                            ? true
                                            : false
                                    }
                                    onChange={handleSelectChange}
                                    value={selected}
                                />
                            </FormLayout.Group>

                            <TextField
                                label="Heading"
                                placeholder="Activate your account"
                                onChange={(value) => setHeading(value)}
                                value={heading}
                                disabled={
                                    shop_plan && shop_plan.plan === "basic"
                                        ? true
                                        : false
                                }
                            />
                            <TextField
                                label="Message"
                                placeholder="Create your password to complete your account setup"
                                onChange={(value) => setMessage(value)}
                                value={message}
                                disabled={
                                    shop_plan && shop_plan.plan === "basic"
                                        ? true
                                        : false
                                }
                            />
                            <FormLayout.Group>
                                <TextField
                                    label="Button Text"
                                    placeholder="Click here to activate"
                                    onChange={(value) => setButtonText(value)}
                                    disabled={
                                        shop_plan && shop_plan.plan === "basic"
                                            ? true
                                            : false
                                    }
                                    value={buttonText}
                                />
                                <div className="select-color">
                                    <div className="select-color-item">
                                        <Popover
                                            active={popoverActivePrimary}
                                            activator={activatorPrimary}
                                            onClose={togglePopoverActivePrimary}
                                        >
                                            <Popover.Section>
                                                <ColorPicker
                                                    onChange={
                                                        handlePrimaryColorChange
                                                    }
                                                    color={primaryColor}
                                                />
                                            </Popover.Section>
                                            <Popover.Section>
                                                <TextField
                                                    value={primaryHexColor}
                                                    label=""
                                                    type="text"
                                                    id="primaryHexColor"
                                                    onChange={
                                                        handlePrimaryHexColorChange
                                                    }
                                                />
                                            </Popover.Section>
                                        </Popover>
                                    </div>
                                </div>

                                <TextField
                                    label="Password Text"
                                    placeholder="Text for Password"
                                    onChange={(value) => setPwdText(value)}
                                    disabled={
                                        shop_plan && shop_plan.plan === "basic"
                                            ? true
                                            : false
                                    }
                                    value={pwdText}
                                />
                                <TextField
                                    label="Confirm Password Text"
                                    placeholder="Text for Confirm Password"
                                    onChange={(value) =>
                                        setConfirmPwdText(value)
                                    }
                                    disabled={
                                        shop_plan && shop_plan.plan === "basic"
                                            ? true
                                            : false
                                    }
                                    value={confirmPwdText}
                                />
                            </FormLayout.Group>
                            <TextField
                                label="Redirect URL (after account activation)"
                                placeholder={`https://${window.shop} with users actual store url`}
                                onChange={(value) => setRedirectUrl(value)}
                                value={redirectUrl}
                                disabled={
                                    shop_plan && shop_plan.plan === "basic"
                                        ? true
                                        : false
                                }
                            />
                            <div>
                                {/* <TextStyle>Remove Branding</TextStyle> */}
                                {/* <br /> */}
                                <Checkbox label="Remove Branding"
                                    disabled={
                                        shop_plan && shop_plan.plan === "basic"
                                            ? true
                                            : false
                                    }
                                    checked={removeBranding}
                                    onChange={setRemoveBranding} />

                                <br />
                                <Checkbox label="Move activation section to very top of order confirmation page"
                                    disabled={
                                        shop_plan && shop_plan.plan === "basic"
                                            ? true
                                            : false
                                    }
                                    checked={topPosition}
                                    onChange={setTopPosition} />
                            </div>
                        </FormLayout>
                    </Card>
                </Layout.AnnotatedSection>

                <Layout.AnnotatedSection
                    title="Conditional Logic"
                    description={desc_logic}
                // description="Only show account activation section if the following products/collections are included in the order. "
                >
                    <Card sectioned>
                        <h3>Choose Products (leave blank to show always)</h3>
                        <br />
                        <Stack>
                            <Button
                                onClick={toggleProductModel}
                                disabled={
                                    shop_plan && shop_plan.plan === "basic"
                                        ? true
                                        : false
                                }
                            >
                                Choose Products
                            </Button>
                            <Button
                                onClick={toggleCollectionModel}
                                disabled={
                                    shop_plan && shop_plan.plan === "basic"
                                        ? true
                                        : false
                                }
                            >
                                Choose Collection
                            </Button>
                        </Stack>
                        {ProductModal && (
                            <ResourcePicker
                                resourceType="Product"
                                showVariants={false}
                                onCancel={toggleProductModel}
                                onSelection={(selectPayload) => {

                                    setProduct(selectPayload);
                                    funproductSelections(selectPayload);
                                }}
                                open={ProductModal}
                                allowMultiple
                                initialSelectionIds={productSelectorArray}
                            />
                        )}
                        {CollectionModal && (
                            <ResourcePicker
                                resourceType="Collection"
                                onCancel={toggleCollectionModel}
                                onSelection={(selectPayload) => {

                                    setCollection(selectPayload);
                                    funCollectionSelection(selectPayload);
                                }}
                                open={CollectionModal}
                                allowMultiple
                                initialSelectionIds={collectionSelectorArray}
                            />
                        )}
                        <br />

                        {shop_plan && shop_plan.plan !== "basic"
                            ? product && product.selection
                                ? Array.isArray(product.selection) &&
                                product.selection.length > 0 &&
                                product.selection.map((item, index) => {

                                    return (
                                        <span className="custom-tag">
                                            <Tag
                                                onRemove={() => {
                                                    removeProduct(item);
                                                }}
                                            >
                                                {item.title}
                                            </Tag>{" "}
                                        </span>
                                    );
                                })
                                : selectedProduct &&
                                Object.keys(selectedProduct) &&
                                Array.isArray(Object.keys(selectedProduct)) &&
                                Object.keys(selectedProduct).length > 0 &&
                                Object.keys(selectedProduct).map((key) => {
                                    let title = selectedProduct[key];

                                    return (
                                        <span className="custom-tag">
                                            <Tag
                                                onRemove={() => {
                                                    removeSelectedProduct(
                                                        selectedProduct[key],
                                                        key
                                                    );
                                                }}
                                            >
                                                {title}
                                            </Tag>
                                        </span>
                                    );
                                })
                            : null}
                        {shop_plan && shop_plan.plan !== "basic"
                            ? collection && collection.selection
                                ? Array.isArray(collection.selection) &&
                                collection.selection.length > 0 &&
                                collection.selection.map((item, index) => {

                                    return (
                                        <span className="custom-tag">
                                            <Tag
                                                onRemove={() => {
                                                    removeCollection(item);
                                                }}
                                            >
                                                {item.title}
                                            </Tag>{" "}
                                        </span>
                                    );
                                })
                                : selectedCollection &&
                                Object.entries(selectedCollection) &&
                                Array.isArray(
                                    Object.entries(selectedCollection)
                                ) &&
                                Object.entries(selectedCollection).length >
                                0 &&
                                Object.entries(selectedCollection).map(
                                    (key) => {
                                        return (
                                            <span className="custom-tag">
                                                <Tag
                                                    onRemove={() => {
                                                        removeSelectedCollection(
                                                            selectedCollection,
                                                            key
                                                        );
                                                    }}
                                                >
                                                    {key[1]}
                                                </Tag>{" "}
                                            </span>
                                        );
                                    }
                                )
                            : null}
                    </Card>
                </Layout.AnnotatedSection>
            </Layout>
            <div style={{ textAlign: "end", margin: "3% 0" }}>
                <Button
                    disabled={
                        shop_plan && shop_plan.plan === "basic" ? true : false
                    }
                    primary
                    onClick={addNewData}
                    loading={loading}
                    monochrome={!loading}
                >
                    Save
                </Button>
            </div>
        </div>
    );
}
